import { Heading, Paragraph } from '@purpurds/purpur';

import CardContentWrapper from 'components/custom/card-content-wrapper/CardContentWrapper';
import { renderRichText } from 'utils/rich-text-render';
import './KeyPointCards.scss';

type KeyPointCardsProps = {
  title?: string;
  cta?: {
    text?: string;
    url?: string;
  };
  preamble?: string;
  items: {
    title: string;
    body: {
      json: any;
    };
  }[];
};

const KeyPointCards = ({ title, cta, preamble, items }: KeyPointCardsProps) => {
  return (
    <CardContentWrapper title={title} isTitleCentered cta={cta} preamble={preamble}>
      <section className="key-point-cards">
        {items.map((item, index: number) => (
          <div key={item.title + index} className="key-point-cards__item">
            <Heading variant="title-200" tag="h3" negative>
              {item.title}
            </Heading>
            <Paragraph negative>{renderRichText(item.body.json)}</Paragraph>
          </div>
        ))}
      </section>
    </CardContentWrapper>
  );
};

export default KeyPointCards;
